import React from 'react';
import { palette, type } from '../design';

// TTT-11: payment happens outside the app, so the student has to be told *how* to send proof.
// Since #320 the student attaches the screenshot to the booking with "I've paid", and the
// instructor sees it beside Confirm (#321). So this note points there, never at email (ruling
// from the #320 review). Callers may still pass `email`; it is no longer shown.
export function ProofOfPaymentNote({ style }) {
  return (
    <p style={{
      fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: type.label, color: palette.walnut,
      lineHeight: 1.6, margin: '10px 0 0', textAlign: 'left', ...style,
    }}>
      After paying, attach your payment screenshot to this booking: open My Bookings and tap{' '}
      <strong style={{ color: palette.terracotta }}>I&apos;ve paid</strong>. Your instructor sees it there and confirms your booking.
    </p>
  );
}
